<template>
    <div>
        <a-tabs type="card">
            <a-tab-pane key="1" tab="重点关键词">
                <div class="table">
                <div class="top"><span style="width:40%">分类</span><span style="width: 60%">内容</span></div>
                <div class="list"  v-for="(item , index) in data "><span style="width:40%">{{item.name}}</span><span style="width:60%" title="">{{item.value}}</span></div>
                </div>
            </a-tab-pane>
            <a-tab-pane key="2" tab="所有关键词">
                <div class="table table2">
                    <div class="top"><span  >关键词</span> </div>
                    <div class="list" v-for="(item , index) in dataAll"><span  >{{item.name}}</span> </div>
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>
<script>
    import API from "../api";
    export default {
        name: "keyWord",
        data(){
            return{
                a_customer_id:this.$route.query.id,
                data:[],
                dataAll:[]
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/WebStatistics"; //设置左侧导航2-2 active
        },
        methods:{
            getList(){
                API.service.KEY_GET_LISTALL({ a_customer_id:this.a_customer_id}).then(res => {
                this.dataAll=res.data.data
                })
                API.service.KEY_GET_LIST({ a_customer_id:this.a_customer_id}).then(res => {
                    this.data=res.data.data
                })
            }
        },
        mounted() {
            this.getList()
        }
    }
</script>

<style scoped>
.table{width: 60%}
.table2{width:200px}
.table span{cursor:pointer;display: inline-block;line-height: 46px;padding: 0 16px;box-sizing: border-box;word-break:break-all;overflow: hidden; -webkit-line-clamp: 1;-webkit-box-orient: vertical;}
.table .list{border-bottom: 1px solid #e8e8e8 }
.top{background-color: #fafafa}
</style>
